document.addEventListener("DOMContentLoaded", function() {
  const container = document.querySelector("#collapsible-description");
  if (!container) return;

  // If the input already has HTML headings, we’ll use them
  const html = container.innerHTML.trim();

  // Create a temporary parser
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const nodes = Array.from(tempDiv.childNodes);
  let sections = [];
  let currentHeader = null;
  let currentContent = [];

  function pushSection() {
    if (currentHeader) {
      sections.push({
        title: currentHeader,
        content: currentContent.map(n => n.outerHTML || n.textContent).join("")
      });
    }
    currentContent = [];
  }

  nodes.forEach(node => {
    const tag = (node.tagName || "").toLowerCase();

    // Detect headers (h2, strong standalone paragraph, or bolded line)
    if (tag === "h2" || (tag === "p" && node.innerText.trim().length < 80 && node.querySelector("strong"))) {
      if (currentHeader) pushSection();
      currentHeader = node.textContent.trim();
    } else {
      if (!currentHeader && node.textContent.trim()) {
        // If content starts before any header, assume "Product Details"
        currentHeader = "Product Details";
      }
      if (currentHeader) currentContent.push(node);
    }
  });

  if (currentHeader) pushSection();

  // If we still have no sections (plain text fallback)
  if (sections.length === 0) {
    const text = container.innerText || "";
    sections = [{ title: "Product Details", content: `<p>${text}</p>` }];
  }

  // Build collapsible markup
  const output = sections.map((s, i) => `
    <details class="collapsible" ${i === 0 ? "open" : ""}>
      <summary><h2>${s.title}</h2></summary>
      <div class="content">${s.content}</div>
    </details>
  `).join("");

  container.innerHTML = output;
});
